module.exports = __webpack_public_path__ + "media/images/photography/grown_up_cms/trevor-302920c80bc503298bcb379cce877def.jpg";